export enum Time {
  SEC = 1e3,
  MIN = 6e4,
  HOUR = 3.6e6,
  DAY = 8.64e7,
  WEEK = 6.048e8,
  MONTH_30 = 2.592e9,
  MONTH_31 = 2.6784e9,
  YEAR = 3.1536e10,
  YEAR_LEAP = 3.16224e10,
}
